<script setup>
import { WButton } from '@alice-health/wonderland-vue'
import { ref } from 'vue'

import UploadInput from './UploadInput.vue'

const props = defineProps({
  value: { type: Array, default: undefined },
  uploadFile: { type: Function, default: undefined },
  loading: Boolean,
  disabled: Boolean
})
const emit = defineEmits(['input'])
const uploadInput = ref(null)

const showFilePrompt = () => {
  uploadInput.value.showFilePrompt()
}
const fileUpload = async files => {
  const attachment = await props.uploadFile(files[0])
  if (!attachment) return
  emit('input', [...(props.value || []), attachment])
}
</script>

<template>
  <div>
    <UploadInput
      ref="uploadInput"
      name="fileInput"
      hidden
      @upload="fileUpload"
    />
    <WButton
      size="small"
      icon="icAttachment"
      icon-button
      variant="tertiary"
      :disabled="disabled"
      :loading="loading"
      data-testid="upload-button"
      @click="showFilePrompt"
    >
    </WButton>
  </div>
</template>
